/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect, useMemo } from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';

import OnTraccrTextInput from '../common/inputs/OnTraccrTextInput';
import AddressLink from '../common/text/AddressLink';
import FormTextInput from '../common/inputs/FormTextInput';
import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';

import { FOOTER_HEIGHT } from '../constants/Styles';

const formStyle = { marginBottom: FOOTER_HEIGHT, paddingBottom: 0 };

const formLabelStyle = {
  style: {
    paddingBottom: 5,
    marginTop: 20,
  },
};

const hasBilling = (billingAddress) => billingAddress !== undefined && billingAddress !== null;

function ContactAddress({
  isNotDisplay,
  officeAddress,
  billingAddress,
}) {
  const [billingDisabled, setBillingDisabled] = useState(!hasBilling(billingAddress));

  useEffect(() => {
    setBillingDisabled(!hasBilling(billingAddress));
  }, [billingAddress]);

  const billingInput = useMemo(() => {
    if (isNotDisplay && billingDisabled) return null;
    if (isNotDisplay) return <OnTraccrTextInput />;
    return <AddressLink address={billingAddress || officeAddress} />;
  }, [isNotDisplay, billingDisabled, billingAddress, officeAddress]);

  return (
    <>
      <FormTextInput
        isNotDisplay={isNotDisplay}
        value={officeAddress}
        name="officeAddress"
        label="Office Address"
        isAddress
      />
      <div className="customer-billing-address-container">
        {isNotDisplay && (
          <OnTraccrCheckbox
            value={billingDisabled}
            className="customer-billing-address-checkbox"
            onChange={setBillingDisabled}
            label="Use Office Address"
            style={{ paddingTop: 10 }}
          />
        )}
        <Form.Item
          name="billingAddress"
          label="Billing Address"
          style={formStyle}
          labelCol={formLabelStyle}
        >
          {billingInput}
        </Form.Item>
      </div>
    </>
  );
}

ContactAddress.propTypes = {
  isNotDisplay: PropTypes.bool,
  officeAddress: PropTypes.string,
  billingAddress: PropTypes.string,
};

ContactAddress.defaultProps = {
  isNotDisplay: false,
  officeAddress: null,
  billingAddress: null,
};

export default ContactAddress;
